import { sum } from "./sum";
import { RowComputeParams } from "./types";

export const AVERAGE_UNITS = (params: RowComputeParams) => {
    const { metricKind, mainRowNodes, getterParams, gridViewRef } = params;
    const values = gridViewRef.current
        ?.getMetricValuesForRows(getterParams.column.getColId(), metricKind, mainRowNodes)
        ?.map((value) => {
            if (isNaN(value)) {
                return 0;
            }
            return value;
        });

    if (!values || values.length === 0) {
        return null;
    }
    return sum(values) / values.length;
};
